/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Eyebrow_Routine_StepInputs */

const en_us2_profile_editors_eyebrow_routine_step = /** @type {(inputs: Profile_Editors_Eyebrow_Routine_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training routine · 1 of 2`)
};

const pt_br2_profile_editors_eyebrow_routine_step = /** @type {(inputs: Profile_Editors_Eyebrow_Routine_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotina de treino · 1 de 2`)
};

const es_419_profile_editors_eyebrow_routine_step = /** @type {(inputs: Profile_Editors_Eyebrow_Routine_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rutina de entrenamiento · 1 de 2`)
};

const pt_pt2_profile_editors_eyebrow_routine_step = /** @type {(inputs: Profile_Editors_Eyebrow_Routine_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rotina de treino · 1 de 2`)
};

const fr_fr2_profile_editors_eyebrow_routine_step = /** @type {(inputs: Profile_Editors_Eyebrow_Routine_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rythme d'entraînement · 1 sur 2`)
};

const de_de2_profile_editors_eyebrow_routine_step = /** @type {(inputs: Profile_Editors_Eyebrow_Routine_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingsroutine · 1 von 2`)
};

const it_it2_profile_editors_eyebrow_routine_step = /** @type {(inputs: Profile_Editors_Eyebrow_Routine_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Routine di allenamento · 1 di 2`)
};

/**
* | output |
* | --- |
* | "Training routine · 1 of 2" |
*
* @param {Profile_Editors_Eyebrow_Routine_StepInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_eyebrow_routine_step = /** @type {((inputs?: Profile_Editors_Eyebrow_Routine_StepInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Eyebrow_Routine_StepInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_eyebrow_routine_step(inputs)
	if (locale === "es-419") return es_419_profile_editors_eyebrow_routine_step(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_eyebrow_routine_step(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_eyebrow_routine_step(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_eyebrow_routine_step(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_eyebrow_routine_step(inputs)
	return en_us2_profile_editors_eyebrow_routine_step(inputs)
});
export { profile_editors_eyebrow_routine_step as "profile-editors.eyebrow_routine_step" }